const MAP_MAGIC_TAGS = {
  job_position_name: 'MagicTag_jobPositionName',
  first_name: 'MagicTag_candidateFirstName',
  last_name: 'MagicTag_candidateLastName',
  organization_name: 'MagicTag_organizationName',
};

export default MAP_MAGIC_TAGS;
